<template>
	<div class="usrTag">
		<!--弹出框-->
		<el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="800px" :close="handleClose" top="13vh">
			<div class="dialogMain">
				<el-row :gutter="10">
					<el-col :span="11">
						<dl>
							<dt><span class="checktip">*</span>系列名称：</dt>
							<dd class="cf">
								<el-input v-model="dialogData.name" class="inputWidth1" placeholder="系列名称"></el-input>
							</dd>
						</dl>
						<dl>
							<dt><span class="checktip">&ensp;</span>所属企业：</dt>
							<el-select v-model="dialogData.enterpriseId" placeholder="选择企业" filterable class="inputWidth1">
								<el-option v-for="item in enterpriseOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</dl>
						<dl>
							<dt><span class="checktip">&emsp;*</span>上下架：</dt>
							<dd class="cf">
								<el-switch
								  v-model="dialogData.status"
								  active-color="#13ce66"
								  inactive-color="#ff4949">
								</el-switch>
								<span style="padding-left: 60px;">公开：</span>
								<el-switch
								  v-model="dialogData.isPublic"
								  active-color="#13ce66"
								  inactive-color="#ff4949">
								</el-switch>
							</dd>
						</dl>
						<dl>
							<dt><span class="checktip">*</span>系列价位：</dt>
							<dd class="cf direction">
								<el-input v-model="dialogData.price.min" style="width: 100px;" placeholder="最低" type="number"></el-input>
								<span>&ensp;~&ensp;</span>
								<el-input v-model="dialogData.price.max" style="width: 100px;" placeholder="最高" type="number"></el-input>
							</dd>
						</dl>
						<dl>
							<dt><span class="checktip">*</span>系列类型：</dt>
							<el-select v-model="dialogData.seriesTypeId" placeholder="选择类型" class="inputWidth1">
								<el-option v-for="item in seriesTypeOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</dl>
						<dl>
							<dt><span class="checktip">*</span>系列风格：</dt>
							<el-select v-model="dialogData.styleId" placeholder="选择风格" class="inputWidth1">
								<el-option v-for="item in styleOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</dl>
						<dl>
							<dt><span class="checktip">*</span>系列品牌：</dt>
							<dd class="cf direction">
								<el-select v-model="dialogData.brandId" placeholder="选择品牌" class="inputWidth1">
									<el-option v-for="item in brandOptions" :key="item.id" :label="item.name" :value="item.id">
									</el-option>
								</el-select>
							</dd>
						</dl>
					</el-col>
					<el-col :span="13">
						<dl>
							<dt><span class="checktip">*</span>上传文件：</dt>
							<dd class="cf">
		    					<div id="containerFile">
		        					<el-button type="primary" id="postFile">上传dxf文件</el-button>
		        					<span class="el-upload__tip" style="padding-left: 20px;">只能上传dxf文件</span>
		        				</div>
		    					<div id="ossfile1" v-show="uploadFileIsOk">
		    						<div>
		    							{{dialogData.fileUrlName}}
		    							<b class="fr">
		    								<span>{{responseFileData}}</span>
		    							</b>
										<div class="progress">
											<div class="progressFile-bar"></div>
										</div>
									</div>
		    					</div>
							</dd>
						</dl>
						<dl>
							<dt><span class="checktip">*</span>上传图片：</dt>
							<dd class="cf">
		    					<div id="container">
		        					<el-button type="primary" id="postImg">上传图片</el-button>
		        					<span class="el-upload__tip" style="padding-left: 20px;">只能上传jpg/png文件，且不超过1MB</span>
		        				</div>
		    					<div id="ossfile" v-show="uploadImgIsOk">
		    						<div>
		    							{{dialogData.imgUrlName}}
		    							<b class="fr">
		    								<span>{{responseImgData}}</span>
		    							</b>
										<div class="progress">
											<div class="progress-bar"></div>
										</div>
									</div>
		    					</div>
							</dd>
						</dl>
						<dl>
							<dt>&ensp;系列描述：</dt>
							<dd class="cf direction">
								<el-input type="textarea" v-model="dialogData.description" :rows="4" placeholder="描述" ></el-input>
							</dd>
						</dl>
					</el-col>
				</el-row>
			</div>
			<span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()" :loading="loading">确 定</el-button>
		  </span>
		</el-dialog>
		<navZcy v-bind:num="'3-6'" style="min-width: 1110px;"></navZcy>
		<div class="line"></div>
		<div class="main" style="width: 1400px;">
			<div class="top cf">
				<div class="topL fl"><span>系列表</span></div>
				<div class="topR fr">
					<el-button type="success" plain @click="refresh"><i class="el-icon-refresh"></i>刷新</el-button>
				</div>
			</div>
			<div class="line"></div>
			<div class="line"></div>
			<div class="dataTag">
				<div class="handle">
					<div class="fl">
						<img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
						<span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
					</div>
					<div class="handleBtn fr">
						<el-button type="primary" size="small" @click="handleAdd">添加</el-button>
						<el-button type="danger" size="small" @click="handleDelete(0,0)">批量删除</el-button>
					</div>
				</div>
				<!--筛选-->
				<div class="filtrateMain">
					<el-row style="text-align: center;">
						<el-col :span="4">
							<el-input v-model="filtrateData.name" placeholder="系列名" class="inputWidth"></el-input>
						</el-col>
						<el-col :span="4">
							<el-input v-model="filtrateData.enterpriseName" placeholder="企业名" class="inputWidth"></el-input>
						</el-col>
						<el-col :span="4">
							<el-select v-model="filtrateData.seriesTypeId" placeholder="类型" class="inputWidth">
								<el-option v-for="item in seriesTypeOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="filtrateData.styleId" placeholder="风格" class="inputWidth">
								<el-option v-for="item in styleOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4">
							<el-select v-model="filtrateData.brandId" placeholder="品牌" class="inputWidth">
								<el-option v-for="item in brandOptions" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-col>
						<el-col :span="4" style="line-height: 40px;">
							<el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
							<el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
						</el-col>
					</el-row>
				</div>
				<!--列表内容-->
				<div class="tableData" style="text-align: center;">
					<el-table
						ref="multipleTable"
						:data="tableData"
						border
						@selection-change="handleSelectionChange"
						style="width: 100%;border-bottom: 1px solid #ddd;">
						<el-table-column type="selection" width="50px">
						</el-table-column>
						<el-table-column type="index" label="序号" width="50px">
						</el-table-column>
						<el-table-column prop="name" label="系列名称" width="120px">
						</el-table-column>
						<el-table-column prop="enterpriseName" label="企业名称" width="120px">
						</el-table-column>
						<el-table-column prop="styleId" label="类型" width="120px">
							<template slot-scope="scope">
								{{scope.row.seriesTypeId?seriesTypeIdtoName(scope.row.seriesTypeId):'无'}}
							</template>
						</el-table-column>
						<el-table-column prop="styleId" label="风格" width="120px">
							<template slot-scope="scope">
								{{scope.row.styleId?styleIdtoName(scope.row.styleId):'无'}}
							</template>
						</el-table-column>
						<el-table-column prop="brandId" label="品牌" width="120px">
							<template slot-scope="scope">
								{{scope.row.brandId?brandIdtoName(scope.row.brandId):'无'}}
							</template>
						</el-table-column>
						<el-table-column prop="price" label="价位" width="120px">
							<template slot-scope="scope">
								{{scope.row.price[0]}} ~ {{scope.row.price[1]}}
							</template>
						</el-table-column>
						<el-table-column label="缩略图" width="80px">
							<template slot-scope="scope">
								<img :src="scope.row.imgUrl" height="23px" alt="缩略图"/>
							</template>
						</el-table-column>
						<el-table-column prop="fileUrl" label="dxf文件" width="160px">
							<template slot-scope="scope">
								<input class="disabledInput" :value="scope.row.fileUrl" disabled v-if="scope.row.fileUrl"></input>
							</template>
						</el-table-column>
						<el-table-column label="上下架" width="65px">
							<template slot-scope="scope">
								{{scope.row.status==1?"上架":"下架"}}
							</template>
						</el-table-column>
						<el-table-column label="公开" width="50px">
							<template slot-scope="scope">
								{{scope.row.isPublic==1?"是":"否"}}
							</template>
						</el-table-column>
						<el-table-column prop="description" label="描述" width="100px">
						</el-table-column>
						<el-table-column label="操作">
							<template slot-scope="scope">
								<a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
								<a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<!--分页-->
				<div class="page">
					<el-pagination
						background
						:current-page="tableDataArr.currentPage"
						:page-sizes="[10,20,30,40]"
						:page-size="tableDataArr.pageSize"
						layout="total, sizes, prev, pager, next, jumper"
						:total="tableDataArr.totalSize"
				     	@current-change="handleCurrentChange"
				     	@size-change="handleSizeChange">
					</el-pagination>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import '../assets/css/style.css'
import navZcy from './nav'
export default {
	data() {
		return {
			loading: false,
			dialogTitle: "",		//弹出框标题
			dialogVisible: false,
			dialogData: {
				price: {
					min: '',
					max: ''
				}
			},			//弹出框参数
			filtrateData: {},
			tableData: [],			//列表内容
			tableDataArr: {			//分页参数
				currentPage: 1,
				pageSize: 10,
				totalSize: 0
			},
			multipleSelection: [],
			enterpriseOptions: [],
			seriesTypeOptions: [],
			styleOptions: [],
			brandOptions: [],
			usr: '',
			pwd: '',
			uploader: {},		//上传图片实例
			uploadImgIsOk: false,	//上传图片时是否显示上传进度条
			responseImgData: '',	//上传图片进度条百分比
			fileUploader: {},		//上传图片实例
			uploadFileIsOk: false,	//上传图片时是否显示上传进度条
			responseFileData: '',	//上传图片进度条百分比
		}
	},
	methods: {
		refresh() {
			location.reload();
		},
		//筛选查询
		handleSearch() {
			this.tableDataArr.currentPage = 1
			this.getAllSeries()
		},
		//重置筛选
		handleReset() {
			this.filtrateData = {}
		},
		//获取企业
		getEnterpriseTag() {
			let url = "/lightApi/enterprise/getAllEnterprise/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.getEnterpriseFn,'vue':this})
		},
		getEnterpriseFn(data) {
			console.log(data)
			if(data.msg=="ok"){
				this.enterpriseOptions = data.data
			}else{
				this.enterpriseOptions = []
			}
		},
		enterpriseIdtoName(id) {
			for (let i=0; i<this.enterpriseOptions.length; i++) {
				if(id==this.enterpriseOptions[i].id){
					return this.enterpriseOptions[i].name
				}
			}
			return ''
		},
		//获取系列类型
		getSeriesType() {
			let url = "/lightApi/seriesType/inquirySeriesType/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.getSeriesTypeFn,'vue':this})
		},
		getSeriesTypeFn(data) {
			if(data.msg=="ok"){
				this.seriesTypeOptions = data.data.items
			}else{
				this.seriesTypeOptions = []
			}
		},
		seriesTypeIdtoName(id) {
			for (let i=0; i<this.seriesTypeOptions.length; i++) {
				if(id==this.seriesTypeOptions[i].id){
					return this.seriesTypeOptions[i].name
				}
			}
		},
		//获取风格类型
		getStyleTag() {
			let url = "/lightApi/style/inquiryStyle/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data': {},'Fn': this.getStyleTagFn,'vue':this})
		},
		getStyleTagFn(data) {
			if(data.msg=="ok"){
				this.styleOptions = data.data.items
			}else{
				this.styleOptions = []
			}
		},
		styleIdtoName(id) {
			for (let i=0; i<this.styleOptions.length; i++) {
				if(id==this.styleOptions[i].id){
					return this.styleOptions[i].name
				}
			}
		},
		//获取系列品牌类型
		getBrandTag() {
			let url = "/lightApi/brand/inquiryBrand/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url':url, 'data':{}, 'vue':this, 'Fn':this.queryBrandFn})
		},
		queryBrandFn(data) {
			if(data.msg=="ok"){
				this.brandOptions = data.data.items
			}else{
				this.brandOptions = []
			}
		},
		brandIdtoName(id) {
			for (let i=0; i<this.brandOptions.length; i++) {
				if(id==this.brandOptions[i].id){
					return this.brandOptions[i].name
				}
			}
		},
		//获取系列
		getAllSeries() {
			let data = {
				name: this.filtrateData.name,
				seriesTypeId:this.filtrateData.seriesTypeId,
				enterpriseName: this.filtrateData.enterpriseName,
				styleId: this.filtrateData.styleId,
				brandId: this.filtrateData.brandId,
				currentPage: this.tableDataArr.currentPage,
				pageSize: this.tableDataArr.pageSize
			}
			let url = "/lightApi/series/inuqirySeries/"+sessionStorage.getItem('sessionId')
			this.$store.dispatch('handlePost',{'url': url, 'data':data,'Fn': this.getAllSeriesFn,'vue':this})
		},
		getAllSeriesFn(data) {
			if(data.msg=="ok"){
				this.tableDataArr = data.data
				this.tableData = this.tableDataArr.items
			}else{
				this.tableData = []
				this.tableDataArr.totalSize = 0
			}
		},
		handleClose: function(done) {
			done();
		},
		//添加系列
		handleAdd: function() {
			this.loading = false
			this.dialogTitle = "添加系列详细";
			this.dialogData={
				name: '',
				seriesTypeId: '',
				enterpriseId: '',
				enterpriseName: '',
				status: true,
				isPublic: true,
				price: {
					min: '',
					max: ''
				},
				brandId: '',
				styleId: '',
				imgUrl: '',
				imgMd5: '',
				fileUrl: '',
				fileMd5: '',
				description: ''
			};
			this.uploadImgIsOk = false
			this.responseImgData = ''
            $('.progress .progress-bar').css('width','0px')
			this.uploadFileIsOk = false
			this.responseFileData = ''
            $('.progress .progressFile-bar').css('width','0px')
			this.dialogVisible = true;
			var vue = this
			setTimeout(function(){
				$('.input').focus()
				if(!vue.usr){
					vue.getOss()
				}
			},100)
		},
		//编辑系列
		handleEdit: function(index, row) {
			console.log(row)
			this.loading = false
			this.dialogTitle = "编辑系列详细";
			let imgName = ''
			let fileName = ''
			if(row.imgUrl){
				imgName = row.imgUrl.split("/")
				imgName = imgName[imgName.length-1]
				this.uploadImgIsOk = true
				this.responseImgData = '成功'
	            $('.progress .progress-bar').css('width','300px')
	            $('.progress .progress-bar').attr('aria-valuenow', '100')
			}
			if(row.fileUrl){
				fileName = row.fileUrl.split("/")
				fileName = fileName[fileName.length-1]
				this.uploadFileIsOk = true
				this.responseFileData = '成功'
	            $('.progress .progressFile-bar').css('width','300px')
	            $('.progress .progressFile-bar').attr('aria-valuenow', '100')
			}
			this.dialogData = {
				id: row.id,
				seriesTypeId: row.seriesTypeId,
				enterpriseId: row.enterpriseId,
				enterpriseName: row.enterpriseName,
				name: row.name,
				status: row.status==1?true:false,
				isPublic: row.isPublic==1?true:false,
				price: {
					min: row.price[0],
					max: row.price[1]
				},
				brandId: row.brandId,
				styleId: row.styleId,
				imgUrlName: imgName,
				imgUrl: row.imgUrl,
				imgMd5: row.imgMd5,
				fileUrlName: fileName,
				fileUrl: row.fileUrl,
				fileMd5: row.fileMd5,
				description: row.description
			};
			this.dialogData.enterpriseName = this.enterpriseIdtoName(row.enterpriseId)
			if(this.dialogData.enterpriseName==''){
				this.dialogData.enterpriseId = ''
			}
			this.dialogVisible = true;
			var vue = this
			setTimeout(function(){
				$('.input').focus()
				if(!vue.usr){
					vue.getOss()
				}
			},100)
		},
		//确定
		handleConfirm: function() {
			this.loading = true
			if(this.dialogData.name.trim()){
				let url = ""
				let data = {
					name: this.dialogData.name,
					seriesTypeId: this.dialogData.seriesTypeId,
					enterpriseId: this.dialogData.enterpriseId,
					enterpriseName: this.enterpriseIdtoName(this.dialogData.enterpriseId),
					status: this.dialogData.status?1:2,
					isPublic: this.dialogData.isPublic?1:2,
					price: [parseInt(this.dialogData.price.min),parseInt(this.dialogData.price.max)],
					brandId: this.dialogData.brandId,
					styleId: this.dialogData.styleId,
					imgUrl: this.dialogData.imgUrl,
					imgMd5: this.dialogData.imgMd5,
					fileUrl: this.dialogData.fileUrl,
					fileMd5: this.dialogData.fileMd5,
					description: this.dialogData.description
				}
				if(!this.dialogData.id){
					url = "/lightApi/series/createSeries/"+sessionStorage.getItem('sessionId')
				}else{
					url = "/lightApi/series/updateSeries/"+sessionStorage.getItem('sessionId')
					data.id = this.dialogData.id
				}
				this.$store.dispatch('handlePost',{'url': url, 'data': data,'Fn': this.handleConfirmFn,'vue':this})
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: '请输入系列名称'
				});
			}
		},
		handleConfirmFn(data) {
			if(data.msg=="ok"){
				this.getAllSeries()
				this.dialogVisible = false
			}else{
				this.loading = false
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
		//图片直传OSS
		uploadImg(){
	    	var vue = this;
	    	var policyText = {
			    "expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
			    "conditions": [
			    	["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
			    ]
			};
			var accessid= this.usr;
			var accesskey= this.pwd;
			var host = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com';

			var policyBase64 = Base64.encode(JSON.stringify(policyText))
			var message = policyBase64
			var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true }) ;
			var signature = Crypto.util.bytesToBase64(bytes);
			var filePath = ''
			this.uploader = new plupload.Uploader({
				runtimes : 'html5,flash,silverlight,html4',
				browse_button : 'postImg',
//			    runtimes : 'flash',
				container: document.getElementById('container'),
				flash_swf_url : 'static/plupload-2.1.2/js/Moxie.swf',
				silverlight_xap_url : 'static/plupload-2.1.2/js/Moxie.xap',
				filters: {
					mime_types : [ //只允许上传图片和zip文件
						{ title : "Image files", extensions : "jpg,png" },
					],
					max_file_size : '1024kb',
				},

			    url : host,

				multipart_params: {
					'Filename': '${filename}',
			        'key' : '${filename}',
					'policy': policyBase64,
			        'OSSAccessKeyId': accessid,
			        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
					'signature': signature,
				},

				init: {
					FilesAdded: function(up, files) {
						plupload.each(files, function(file) {
							var oDate = new Date()
							let type = file.name.split(".")
							let pakName = oDate.getTime()+"."+type[type.length-1]
							filePath = 'LightFile/photo/'+oDate.getFullYear()+"/"+(oDate.getMonth()+1)+"/"+oDate.getDate()+"/"+pakName
							let	multipart_paramsb=  {
								'Filename': '${filename}',
						        'key' : filePath,
								'policy': policyBase64,
						        'OSSAccessKeyId': accessid,
						        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
								'signature': signature
							}
							vue.uploader.setOption("multipart_params",multipart_paramsb);
							vue.dialogData.imgUrlName = pakName
							vue.responseImgData = ''
							$('.progress-bar').css('width','0px')
			            	$('.progress-bar').attr('aria-valuenow', '0')
							vue.uploadImgIsOk = true
							vue.uploader.start();
						});
					},
					UploadProgress: function(up, file) {
			            vue.responseImgData = file.percent + "%"
			            $('.progress-bar').css('width',3*file.percent+'px')
			            $('.progress-bar').attr('aria-valuenow', file.percent)
					},
					FileUploaded: function(up, file, info) {
			            if (info.status >= 200 || info.status < 200){
			            	vue.hashMd5('img',file.getNative())
			            	vue.responseImgData = '成功'
							vue.dialogData.imgUrl = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com/'+filePath
						}else{
			            	vue.responseImgData = info.response
			            	vue.dialogData.imgUrl = ''
			            	$('.progress-bar').css('width','0px')
			            	$('.progress-bar').attr('aria-valuenow', '0')
			            }
					},

					Error: function(up, err) {
//						console.log(err)
						if(err.message == 'File size error.'){
							vue.$message.error('上传头像图片大小不能超过 1MB!');
						}else{
							vue.$message.error(err.message);
						}

					}
				}
			});
	    },
	    //文件直传OSS
		uploadFile(){
	    	var vue = this;
	    	var policyText = {
			    "expiration": "2030-01-01T12:00:00.000Z", //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
			    "conditions": [
			    	["content-length-range", 0, 1048576000] // 设置上传文件的大小限制
			    ]
			};
			var accessid= this.usr;
			var accesskey= this.pwd;
			var host = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com';

			var policyBase64 = Base64.encode(JSON.stringify(policyText))
			var message = policyBase64
			var bytes = Crypto.HMAC(Crypto.SHA1, message, accesskey, { asBytes: true }) ;
			var signature = Crypto.util.bytesToBase64(bytes);
			var filePath = ''
			this.fileUploader = new plupload.Uploader({
				runtimes : 'html5,flash,silverlight,html4',
				browse_button : 'postFile',
//			    runtimes : 'flash',
				container: document.getElementById('containerFile'),
				flash_swf_url : 'static/plupload-2.1.2/js/Moxie.swf',
				silverlight_xap_url : 'static/plupload-2.1.2/js/Moxie.xap',
				filters: {
					mime_types : [ //只允许上传图片和zip文件
						{ title : "Dxf files", extensions : "dxf" },
					]
				},

			    url : host,

				multipart_params: {
					'Filename': '${filename}',
			        'key' : '${filename}',
					'policy': policyBase64,
			        'OSSAccessKeyId': accessid,
			        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
					'signature': signature,
				},

				init: {
					FilesAdded: function(up, files) {
						plupload.each(files, function(file) {
							var oDate = new Date()
							let type = file.name.split(".")
							let pakName = oDate.getTime()+"."+type[type.length-1]
							filePath = 'LightFile/dxf/'+oDate.getFullYear()+"/"+(oDate.getMonth()+1)+"/"+oDate.getDate()+"/"+pakName
							let	multipart_paramsb=  {
								'Filename': '${filename}',
						        'key' : filePath,
								'policy': policyBase64,
						        'OSSAccessKeyId': accessid,
						        'success_action_status' : '200', //让服务端返回200,不然，默认会返回204
								'signature': signature
							}
							vue.fileUploader.setOption("multipart_params",multipart_paramsb);
							vue.dialogData.fileUrlName = pakName
							vue.responseFileData = ''
							$('.progressFile-bar').css('width','0px')
			            	$('.progressFile-bar').attr('aria-valuenow', '0')
							vue.uploadFileIsOk = true
							vue.fileUploader.start();
						});
					},
					UploadProgress: function(up, file) {
			            vue.responseFileData = file.percent + "%"
			            $('.progressFile-bar').css('width',3*file.percent+'px')
			            $('.progressFile-bar').attr('aria-valuenow', file.percent)
					},
					FileUploaded: function(up, file, info) {
						console.log(info)
			            if (info.status >= 200 || info.status < 200){
			            	vue.hashMd5('file',file.getNative())
			            	vue.responseFileData = '成功'
							vue.dialogData.fileUrl = 'http://zcvrstorage.oss-cn-shenzhen.aliyuncs.com/'+filePath
						}else{
			            	vue.responseFilegData = info.response
			            	vue.dialogData.fileUrl = ''
			            	$('.progressFile-bar').css('width','0px')
			            	$('.progressFile-bar').attr('aria-valuenow', '0')
			            }
					},

					Error: function(up, err) {
						console.log(err)
						vue.$message.error(err.message);

					}
				}
			});
	    },
	    //获取OSS密令
	    getOss: function(){
	    	this.$http.get("/lightApi/oss/getOssMsg/" + sessionStorage.getItem('sessionId'),{},{emulateJson:true}).then(
				(succeed)=>{
//					console.log(succeed)
					if(succeed.body.msg=="ok"){
						this.usr=succeed.body.data.accessid;
						this.pwd=succeed.body.data.accesskey;
						this.uploadFile()
						this.fileUploader.init()
						this.uploadImg()
						this.uploader.init()
					}else{
						if(succeed.body.msg=='该SessionId不存在'||succeed.body.msg=='该SessionId已经超时'){
//							this.sessionTimeout(succeed.body.msg)
						}
					}
				}
			)
	    },
		//计算文件的MD5
		hashMd5(fileType,item){
	    	var vue = this
		   	var fileReader = new FileReader(),
	        blobSlice = File.prototype.mozSlice || File.prototype.webkitSlice || File.prototype.slice,
	        file = item,
	        chunkSize = 2097152,
	        chunks = Math.ceil(file.size / chunkSize),
	        currentChunk = 0,
	        spark = new SparkMD5();
		    fileReader.onload = function(e) {
		        spark.appendBinary(e.target.result); // append binary string
		        currentChunk++;

		        if (currentChunk < chunks) {
		            loadNext();
		        }else {
		        	//拼接上传路径
		        	if(fileType == "img"){
		        		vue.dialogData.imgMd5 = spark.end()
		        	}else{
		        		vue.dialogData.fileMd5 = spark.end()
		        	}
		        }
		    };
		    function loadNext() {
		        var start = currentChunk * chunkSize,
		            end = start + chunkSize >= file.size ? file.size : start + chunkSize;

		        fileReader.readAsBinaryString(blobSlice.call(file, start, end));
		    };
		    loadNext();
		},
		handleSelectionChange: function(val){
			this.multipleSelection=[]
			for (let i=0; i<val.length; i++) {
				this.multipleSelection.push(val[i].id)
			}
		},
		//删除系列
		handleDelete: function(index, row) {
			let id = []
			if(row!=0){
				id[0] = row.id
			}else{
				id = this.multipleSelection
			}
			if(id.length>0){
				this.$confirm('此操作将永久删除该系列标签, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let url = "/lightApi/series/deleteSeries/"+sessionStorage.getItem('sessionId')+"/"+id
					this.$store.dispatch('handleGet',{'url': url,'Fn': this.handleDeleteFn,'vue':this})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			}else{
				this.$message({
					type: 'info',
					message: '请选择删除项'
				});
			}
		},
		handleDeleteFn(data) {
			if(data.msg=="ok"){
				this.getAllSeries()
				this.$message({
					type: 'success',
					message: '删除成功!'
				});
			}else{
				this.$message({
					type: 'error',
					message: data.msg
				});
			}
		},
        //点击页数
		handleCurrentChange(cur) {
			this.tableDataArr.currentPage = cur
			this.getAllSeries()
		},
		handleSizeChange(size) {
			this.tableDataArr.pageSize = size
			this.getAllSeries()
		}
	},
	created() {
		this.getSeriesType()
		this.getStyleTag()
		this.getBrandTag()
		this.getEnterpriseTag()
	},
	mounted() {
		this.getAllSeries()
	},
	components: {
		navZcy
	}
}
</script>

<style scoped>
	.dialogMain dl dt,.dialogMain dl dd{
		line-height: 40px;
	}
	.inputWidth1{
		width: 230px;
	}

	#ossfile{
	    width: 300px;
		margin-top: 20px;
	}
	.progress{
		margin-top:2px;
	    width: 300px;
	    height: 14px;
	    margin-bottom: 10px;
	    overflow: hidden;
	    background-color: #f5f5f5;
	    border-radius: 4px;
	    -webkit-box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
	    box-shadow: inset 0 1px 2px rgba(0,0,0,.1);
	}
	.progress-bar{
		background-color: rgb(92, 184, 92);
		background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);
		background-size: 40px 40px;
		box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
		box-sizing: border-box;
		color: rgb(255, 255, 255);
		display: block;
		float: left;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		transition-delay: 0s;
		transition-duration: 0.6s;
		transition-property: width;
		transition-timing-function: ease;
		width: 300px;
	}
	.progressFile-bar{
		background-color: rgb(92, 184, 92);
		background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.14902) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.14902) 50%, rgba(255, 255, 255, 0.14902) 75%, transparent 75%, transparent);
		background-size: 40px 40px;
		box-shadow: rgba(0, 0, 0, 0.14902) 0px -1px 0px 0px inset;
		box-sizing: border-box;
		color: rgb(255, 255, 255);
		display: block;
		float: left;
		font-size: 12px;
		height: 20px;
		line-height: 20px;
		text-align: center;
		transition-delay: 0s;
		transition-duration: 0.6s;
		transition-property: width;
		transition-timing-function: ease;
		width: 300px;
	}
	.disabledInput{
		border: none;
    	background: rgba(0,0,0,0);
	}
</style>



// WEBPACK FOOTER //
// src/components/seriesTag.vue